(function($){
    $(document).ready(function() {

        $('a[data-toggle-display]').click(function() {
            var selector = $(this).attr('data-toggle-display');

            $('#' + selector).toggleClass('show-block');
            
            if ($(this).attr('data-animation') == 'fade' && $('#' + selector).hasClass('show-block')) {
                $('#' + selector).css('display', 'block');
                $('#' + selector).animate({
                    opacity: 1
                }, 1000, function() {});
            } else if ($(this).attr('data-animation') == 'fade' && !$('#' + selector).hasClass('show-block')) {
                
                $('#' + selector).animate({
                    opacity: 0
                }, 1000, function() {
                    $('#' + selector).css('display', 'none');
                });
            }
        });

        /* Collapsable Menu Feature */

        if ($(window).outerWidth() > 480) {
            $('#member-sidebar-menu').each(function(){
                var collapse = getCookie('CollapseLPHAdminMenu');
                if (collapse == 'true') {
                    $('#member-sidebar-menu').addClass('collapsed');
                }
            });
        } else {
            $('#member-sidebar-menu').addClass('collapsed');
        }
        $('.collapse-menu a').click(function(event) {
            event.preventDefault();
            $('#member-sidebar-menu').toggleClass('collapsed');
            var collapse = $('#member-sidebar-menu').hasClass('collapsed');
            setCookie('CollapseLPHAdminMenu',collapse,30);
        });

        /* Display Setting Control Feature */

        $('.posts-list div[data-display]').each(function(){
            var display_setting = getCookie('LPHListDisplay');
            if (display_setting == '') {
                var display_setting = 'list';
            } 
            $('.set-display[data-display="' + display_setting + '"]').addClass('active');
            var inactive_display_setting = $('.set-display:not(.active)').attr('data-display');
            if ($(this).attr('data-display') !== '' && $(this).attr('data-display') !== display_setting) {
                var list_class =  $('.posts-list div[data-display]').attr('class').replace(new RegExp(inactive_display_setting, 'g'), display_setting);
                $('.posts-list div[data-display]').attr('class', list_class);
            }
        });
        $('.set-display').click(function() {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            var inactive_display_setting = $('.set-display:not(.active)').attr('data-display');
            var display_setting = $('.set-display.active').attr('data-display');
            var list_class =  $('.posts-list div[data-display]').attr('class').replace(new RegExp(inactive_display_setting, 'g'), display_setting);
            $('.posts-list div[data-display]').attr('class', list_class);


            setCookie('LPHListDisplay', display_setting, 30);
        });

        // When the user scrolls the page, execute initStickyNav 
        window.onscroll = function() {

            initStickyNav();
        };

    function initStickyNav() {

        if($('#top-bar').length && $('#search-block').length && window.location.host.startsWith('lambton') && !$('.private-topbar').length) {

            // Get the required elements
            var navbar = document.getElementById("top-bar");
            var stickyFlag = document.getElementsByTagName("section")[0];
            var searchBar = document.getElementById("search-block");

            // Get the offset position of the navbar
            var sticky = stickyFlag.offsetTop;

            //Get height of the navbar
            var navHeight = $(navbar).outerHeight(); 

            //Get the first article / Hero banner
            var heroBanner = $('.main article .article-header')[0];
            
            // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky");
                searchBar.classList.add("sticky");
                $(heroBanner).css('margin-top', navHeight);
                $('#top-bar .site-logo .custom-logo-link img').attr('width', 70);
                
                //Check if in admin mode for nav position offset
                if ($('#wpadminbar') && $(window.innerWidth)[0] > 600) {
                    $(navbar).css('top', $('#wpadminbar').outerHeight());
                }
                else {
                    $(navbar).css('top', 0);
                }

            } else {
                navbar.classList.remove("sticky");
                searchBar.classList.remove("sticky");
                $('#top-bar .site-logo .custom-logo-link img').attr('width', 139);
                $(heroBanner).css('margin-top', 0);
                $(navbar).css('top', 0);
            }

        }
        
    }

    }); 

    $(window).bind("load", function() {
        var test = new AccessibilityDispatcher();
     });

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    } 

})(jQuery); 

//Class to add accessibility attributes to html generated by plugins that do not natively support WCAG AA Compliance
class AccessibilityDispatcher {

    //Constructor - Get relevant DOM objects
    constructor() {

        this.ticketQuantityElems = $('.tribe-ticket-quantity');
        this.userAvatarLinks = $('.gravatar.avatar.avatar-40.um-avatar.um-avatar-uploaded');
        this.unlabledFormFields = $('input, select, textarea');
        this.loginElems = $('#login-menu');
        this.sociaLinkElems = $('#social-links');
        this.iframes = $('iframe');

        

        this.init();

    }

    //Events
    init() {

        if (this.ticketQuantityElems.length) {
            $(this.ticketQuantityElems).each(function() {
                $(this).attr('aria-label', 'quantity');
            });
        }
        if (this.userAvatarLinks.length) {
            $(this.userAvatarLinks).each(function() {
                $(this).attr('alt', 'User Account');
            });
        }
        if (this.unlabledFormFields.length) {
            $(this.unlabledFormFields).each(function() {
                var attr = $(this).attr('aria-label');
                if(typeof attr == undefined || attr == false || attr == null) {
                    $(this).attr('aria-label', 'Form Field');
                }
            });
        }
        if (this.loginElems.length) {
            $(this.loginElems).attr('id', 'login-menu-1');
        }
        if (this.sociaLinkElems.length) {
            $(this.sociaLinkElems).attr('id', 'social-links-1');
        }
        if (this.iframes.length) {
            $(this.iframes).attr('title', 'iframe content');
        }
    }

}